import { api } from "../api";
import IAnimalService from "./interfaces/IAnimalService";
import IUploadXlsRequest from "./interfaces/request/IUploadXlsRequest";

const animalService: IAnimalService = {
  uploadXls: async ({ idFarm, animal }: IUploadXlsRequest) => {
    return await api.post(`/animal/import/xls?idFarm=${idFarm}`, animal, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  downloadXls: async () => {
    return await api.get(``);
  },
};

export default animalService;
